const RecommendEmailList = [
  '@naver.com',
  '@gmail.com',
  '@nate.com',
  '@hanmail.net',
  '@daum.net',
  '@kakao.com',
  '@yahoo.co.kr',
];

export default RecommendEmailList;
